import bountyActionTypes from './bounties.types';

const INITIAL_STATE = {
    bounties: [],
    isFetching: false,
    isClaiming: false,
    error: undefined,
    success: undefined
};

const bountiesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case bountyActionTypes.FETCH_BOUNTIES_START:
            return {
                ...state,
                isFetching: true
            };
        case bountyActionTypes.FETCH_BOUNTIES_SUCCESS:
            return {
                ...state,
                isFetching: false,
                bounties: action.payload
            };
        case bountyActionTypes.FETCH_BOUNTIES_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        case bountyActionTypes.CLAIM_BOUNTY_START:
            return {
                ...state,
                isClaiming: true,
                error: undefined,
                success: undefined
            };
        case bountyActionTypes.CLAIM_BOUNTY_SUCCESS:
            return {
                ...state,
                isClaiming: false,
                success: 'Bounty claim submitted! Admin will review your evidence.'
            };
        case bountyActionTypes.CLAIM_BOUNTY_FAILURE:
            return {
                ...state,
                isClaiming: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default bountiesReducer;
